import {apiSlice} from './apiSlice';

/**
 * Endpoints module Chấm điểm SEO.
 *
 * - analyzeSeo: gửi {domain, keyword?}, BE craw + chấm điểm + lưu báo cáo, trả kết quả
 *   đầy đủ. keyword (tuỳ chọn) bật nhóm tiêu chí On-page theo từ khoá (#3). Là mutation
 *   (có side-effect: tạo bản ghi) → invalidate 'SeoReport' để lịch sử tự refetch.
 * - getSeoReports / getSeoReport: lịch sử + chi tiết 1 báo cáo.
 * - deleteSeoReport: xoá 1 báo cáo.
 */
export const seoApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		analyzeSeo: builder.mutation({
			query: ({domain, keyword = ''}) => ({url: 'seo/analyze', method: 'post', data: {domain, keyword}}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: ['SeoReport'],
		}),
		getSeoReports: builder.query({
			query: (keyword = '') => ({
				url: 'seo',
				method: 'get',
				...(keyword ? {params: {keyword}} : {}),
			}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['SeoReport'],
		}),
		getSeoReport: builder.query({
			query: (id) => ({url: `seo/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'SeoReport', id}],
		}),
		deleteSeoReport: builder.mutation({
			query: (id) => ({url: `seo/${id}`, method: 'delete'}),
			invalidatesTags: ['SeoReport'],
		}),
	}),
});

export const {
	useAnalyzeSeoMutation,
	useGetSeoReportsQuery,
	useGetSeoReportQuery,
	useDeleteSeoReportMutation,
} = seoApiSlice;
